module.exports = __webpack_public_path__ + "static/media/shema-light.205b42bd.png";